<script lang="ts">
  import { Label } from "$lib/components/ui/label";
  import { Button } from "$lib/components/ui/button";
  import { type ImageType } from "@briefmarken_katalog/types";
  import QRUploadDialog from "./QRUploadDialog.svelte";
  import { t } from "$lib/i18n";

  const { handleImageUpload, onPhoneUpload, isReadonly = false, hasPicture = false } = $props<{
    handleImageUpload: (e: Event) => void;
    onPhoneUpload?: (picture: ImageType) => void;
    isReadonly?: boolean;
    hasPicture?: boolean;
  }>();

  let fileInput = $state<HTMLInputElement | undefined>(undefined);
  let qrOpen = $state(false);
</script>

<div class="grid grid-cols-4 items-center gap-4">
  <Label class="text-right">{$t('fields.photoScan')}</Label>
  <div class="col-span-3 flex flex-wrap gap-2">
    <input
      bind:this={fileInput}
      type="file"
      accept="image/*"
      onchange={handleImageUpload}
      class="hidden"
    />
    <Button variant="outline" onclick={() => fileInput?.click()}>
      {hasPicture ? $t('upload.replaceFile') : $t('upload.chooseFile')}
    </Button>
    {#if onPhoneUpload}
      <Button variant="outline" onclick={() => qrOpen = true}>{$t('upload.button')}</Button>
    {/if}
  </div>
</div>

{#if onPhoneUpload}
  <QRUploadDialog bind:open={qrOpen} onPictureReceived={onPhoneUpload} />
{/if}
